import { Alert } from '@conexasaude/conexa-hero'
import { FunctionComponent } from 'react'
import { useStyles } from './styles'

const IncompatibleBrowserWarning: FunctionComponent = () => {
  const styles = useStyles()

  return (
    <div css={styles.alertWrapper}>
      <Alert
        variant="warning"
        title="Navegador incompatível"
        text="Olá! Parece que você está usando um navegador incompatível com nosso site. Para uma melhor experiência, recomendamos que você use navegadores como Google Chrome, Edge ou Safari."
      />
    </div>
  )
}

export { IncompatibleBrowserWarning }
